import React from "react"
import DeleteFilter from "../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../config/api";
import { production_chart, room_types_chart, adr_chart } from "../widgets/Charts";
import ReactEcharts from "echarts-for-react";
import axios from "axios";

const postUrlLogin = API_URL + "widgets";

class RoomType extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            array_colors : ["#fec400", "#ff7d4d", "#ff4558", "#15d39a"],
            list_rooms : ""
        }
        this.getOptionTypeBar   = this.getOptionTypeBar.bind(this);
    }

    getOptionTypeBar = (chart) => {
        let char_keys = Object.keys(this.props.response_request);

        let xAxis = [], 
        current_year_values = [], 
        last_year_value = [], 
        series = [], 
        hotel_series = [], 
        property_legend = [],
        childs_room     = "",
        rooms;

        let $self = this;
        let result
        if (char_keys.length > 0){
            result          = this.props.response_request["data_room_types"];
            property_legend = result["property_legend"]
            rooms           = result["room_type"];
            Object.keys(rooms).map(function(key, index){
                if(key !==  "children"){
                    hotel_series        = hotel_series.concat(rooms[key]);
                }
            })
            this.state.list_rooms = Object.keys(rooms).map(function(key, index){
                const list_childs = rooms[key]["children"];

                let style_legend = {
                        backgroundColor: rooms[key]["color"],
                    };
                  
                childs_room = Object.keys(list_childs).map((key_aux) => {
                    let style_legend_room = {
                        backgroundColor: list_childs[key_aux].color,
                    };
                    return (
                        <li>
                            <span style={style_legend_room} className="legend-type-room"></span>
                            {list_childs[key_aux].name}
                            <span>{list_childs[key_aux].value}</span>
                        </li>
                    );
                })
                return <li><span style={style_legend} className="legend-type-room"></span>{key}<ul>{childs_room}</ul></li>
            })
        }
        return room_types_chart(hotel_series,property_legend);
    }
    render() {
        return (
            <section>
                <div className={"datagrid-widget room_type"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">PRODUCCIÓN POR HABITACIÓN</span>
                                
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                
                            </div>
                            <div className="row">
                                <div className="col-md-8 datagrid-list chart">
                                    <ReactEcharts
                                        option={this.getOptionTypeBar("data_room_types")}
                                        notMerge={true}
                                        lazyUpdate={true}
                                        theme={"theme_name"}
                                        onChartReady={this.onChartReadyCallback}
                                    />
                                </div>
                                <div className="col-md-4 datagrid-list list-rooms">
                                    <ul className="list-room-type">
                                        {this.state.list_rooms}
                                    </ul>
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>             
            </section>
        )
    }
}

export default RoomType



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/reservations/views/RoomType.js